import dayjs from "dayjs";
import Repository from "@/services/Repository";
const { Student } = require("../models/People");
const relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime);

const resource = "/students";

export default {
  fetchOne(studentId) {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/id/${studentId}`)
        .then(response => {
          let { data } = response;
          data.id = data._id;
          try {
            let student = new Student(data);

            resolve(student);
          } catch (error) {
            console.error(error);
            reject(error);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  async fetch(classroom) {
    let params = {
      classroom
    };
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}`, { params })
        .then(response => {
          let students = response.data.map(data => {
            data.id = data._id;
            let student = new Student(data);

            return student;
          });
          resolve(students);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  async fetchByClassroomInYear({ classroom, schoolYear }) {
    const params = {
      classroom,
      schoolYear
    };

    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/classroom-in-year`, { params })
        .then(response => {
          const students = response.data.map(data => {
            data.id = data._id;
            const student = new Student(data);
            return student;
          });
          resolve(students);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  async fetchAll() {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}`)
        .then(response => {
          let students = response.data.map(data => {
            data.id = data._id;
            let student = new Student(data);
            return student;
          });
          resolve(students);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchNoClassrooms() {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/no-classroom`)
        .then(response => {
          let students = response.data.map(data => {
            data.id = data._id;
            let student = new Student(data);
            return student;
          });
          resolve(students);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchActive() {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/active`)
        .then(response => {
          let students = response.data.map(data => {
            data.id = data._id;
            let student = new Student(data);
            return student;
          });
          resolve(students);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  post(data) {
    return Repository.post(`${resource}/`, data);
  },
  update(editingStudent) {
    return Repository.put(
      `${resource}/id/${editingStudent.id}`,
      editingStudent
    );
  },
  delete(studentId) {
    return Repository.delete(`${resource}/id/${studentId}`);
  },
  addParent(entry) {
    let path = "parents";
    return Repository.post(`${resource}/${path}`, entry);
  },
  addSibling(entry) {
    let path = "siblings";
    return Repository.post(`${resource}/${path}`, entry);
  },
  addNewAddress(entry) {
    let path = "addresses";
    return Repository.post(`${resource}/${path}`, entry);
  },
  updateFamilyStatus(entry) {
    let path = "relationship";
    return Repository.put(`${resource}/${path}`, entry);
  },
  upgradeStudyClass(students, nextStudyClass) {
    return Repository.put(`${resource}/upgrade-many`, {
      students,
      nextStudyClass
    });
  },
  updateHealthProfile({ student, changedEntry }) {
    return Repository.put(`${resource}/${student}/health`, { changedEntry });
  },
  moveToClassroom({ students, studyClass, classroom, schoolYear }) {
    return Repository.put(`${resource}/move-to-classroom`, {
      students,
      studyClass,
      schoolYear,
      classroom
    });
  },
  leaveSchool({ student, studyClass, classroom, schoolYear }) {
    return Repository.put(`${resource}/leave-school`, {
      student,
      studyClass,
      classroom,
      schoolYear
    });
  }
};
